import { Star } from "lucide-react";
import { useState } from "react";
import { europeanJurisdictions, initialFavouriteJurisdictions } from "../lib/jurisdictions";

export function JurisdictionSelect({ value, onChange, label = "Jurisdiction" }: { value: string; onChange: (value: string) => void; label?: string }) {
  const [favourites, setFavourites] = useState(initialFavouriteJurisdictions);
  const favouriteSet = new Set(favourites);
  const remaining = europeanJurisdictions.filter((country) => !favouriteSet.has(country));
  const canFavourite = value && europeanJurisdictions.includes(value) && !favouriteSet.has(value);

  return (
    <label>
      <span className="mb-1 block text-xs font-medium text-muted">{label}</span>
      <div className="grid gap-2 sm:grid-cols-[1fr_auto]">
        <select className="min-h-11 w-full rounded-lg border border-line bg-surface px-3" value={value} onChange={(event) => onChange(event.target.value)}>
          <option value="">Select jurisdiction</option>
          <optgroup label="Favourites">
            {favourites.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </optgroup>
          <optgroup label="European countries">
            {remaining.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </optgroup>
        </select>
        <button
          type="button"
          className="inline-flex min-h-11 items-center justify-center gap-2 rounded-lg border border-line bg-surface px-3 text-sm font-medium text-secondary hover:bg-hover disabled:cursor-not-allowed disabled:opacity-50"
          disabled={!canFavourite}
          onClick={() => {
            if (canFavourite) setFavourites((current) => [value, ...current]);
          }}
        >
          <Star className="h-4 w-4" />
          Favourite
        </button>
      </div>
    </label>
  );
}
